import RedirectHub from "@/telematics/RedirectHub";

export default [
  {
    name: "RedirectHub",
    path: "/telematics/redirect-hub",
    component: RedirectHub,
  },
];
